module.exports = __webpack_public_path__ + "static/img/skill-legend.16721553.png";